import * as React from 'react';
import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { paymentsActionTypes } from '../payments-action-types';
import { IPaymentsAction } from '../payments-interfaces';
import { getFormattedFinancialAccountFormFields } from '../../../constants/financial-account/financial-account-form';
import { requestErrorHandler } from '../../../utils/newApplicationUtils';
import { GET } from '../../store-helper';
import { IFinancialAccountProps } from '../../../components/financial_accaunt/FinancialAccountFilterSection';
import { IPaginationData } from '../../../interfaces/funds';

export const fetchFinancialAccountData = async (searchParams: IFinancialAccountProps): Promise<IPaginationData> => {
  try {

    return await GET({
      pathname: `${BASE_URL.PAYMENTS}/FinancialAccounts`,
      params: searchParams
    });

  } catch (e) {
    console.log('setPartnerBankDetails', e);
  }
};

interface IUpdateFinancialAccountData {
  dispatch: React.Dispatch<IPaymentsAction>;
  formik: any;
  id: string;
  onConfirm: () => void;
}

export const updateFinancialAccountData = async ({ dispatch, formik, id, onConfirm }: IUpdateFinancialAccountData): Promise<void> => {
  if (!formik.isValid) return;
  try {
    dispatch({ type: paymentsActionTypes.SET_UPDATING_FINANCIAL_ACCOUNT_LOADING, payload: true });
    const params = getFormattedFinancialAccountFormFields(formik.values);
    await axios.put(`${BASE_URL.PAYMENTS}/FinancialAccounts/${id}`, params);
    onConfirm();
    dispatch({ type: paymentsActionTypes.SET_UPDATING_FINANCIAL_ACCOUNT_LOADING, payload: false });
  } catch (e) {
    dispatch({ type: paymentsActionTypes.SET_UPDATING_FINANCIAL_ACCOUNT_LOADING, payload: false });
    console.log('setPartnerBankDetails', e);
    requestErrorHandler(e);
  }
};

export const fetchEntityTypes = async (dispatch: React.Dispatch<IPaymentsAction>): Promise<void> => {
  try {
    const res = await axios.get(`${BASE_URL.PAYMENTS}/FinancialAccounts/entity-types`);
    const types = [];
    if (res?.data) {
      res.data?.forEach(el => {
        types.push({ value: el, label: el });
      });
    }
    dispatch({ type: paymentsActionTypes.FETCH_ENTITY_TYPES, payload: types });
  } catch (e) {
    console.log('fetchEntityTypes error', e);
    requestErrorHandler(e);
  }
};